import { render, staticRenderFns } from "./WidgetRevenueReport.vue?vue&type=template&id=703ff10f&"
import script from "./WidgetRevenueReport.vue?vue&type=script&lang=js&"
export * from "./WidgetRevenueReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports